export const buildFilters = filters => {
  if (filters && filters.length > 0) {
    return `&filters=${filters.join(',')}`
  }
  return ''
}

export const buildSource = source => {
  if (source && source !== 'all') {
    return `&sources=${encodeURIComponent(source)}`
  }
  return ''
}

export const buildDistribution = (distribution, isActive) => {
  if (distribution && distribution.length === 2 && isActive) {
    return `&value_from=${distribution[0]}&value_to=${distribution[1]}`
  }
  return ''
}

export const buildDistributionForSharing = distribution => {
  if (distribution && distribution.length === 2) {
    return `&distribution=${distribution[0]},${distribution[1]}`
  }
  return ''
}

export const buildBrands = (activeBrands, allBrands, activeGroups) => {
  const mainBrands = allBrands.filter(
    brand => activeBrands.includes(brand.brand.key) && brand.brand.brand_status === true
  )
  const competitorsArray = allBrands
    .filter(brand => activeBrands.includes(brand.brand.key) && brand.brand.brand_status === false)
    .map(brand => brand.brand.key)
  let brandsUrl = ''
  if (!mainBrands.length && (!activeGroups || activeGroups?.length === 0)) {
    brandsUrl += `&brand=0`
  }
  if (competitorsArray.length) {
    brandsUrl += `&competitor=1&competitors=${competitorsArray.join(',')}`
  }
  return brandsUrl
}

export const buildBrandsForSharing = brands => {
  if (brands && brands.length > 0) {
    return `&brands=${brands.join(',')}`
  }
  return ''
}

export const buildKpi = kpi => {
  if (kpi) {
    return `&kpis=${kpi}`
  }
  return ''
}

export const buildDate = date => {
  if (date && date !== new Date().toISOString().split('T')[0]) {
    return `&date=${date}`
  }
  return ''
}

export const buildLocation = (internalId, distance) => {
  let locationUrl = ''
  if (internalId) {
    locationUrl = `&internal_id=${internalId}`
  }
  if (distance) {
    locationUrl += `&distance=${distance}`
  }
  return locationUrl
}

export const buildLocationMode = (routeName, isFilters = false) => {
  if (routeName === 'markersIntention' && isFilters) return '&location_mode=lge_predictive'

  if (routeName === 'markersIntention' || routeName === 'zonesIntention' || routeName === 'divisionZonesIntention') {
    return `&location_mode=county_prediction`
  }
  return ''
}

export const buildLevel = level => {
  if (level) {
    return `&level=${level}`
  }
  return ''
}

export const buildLocale = locale => {
  if (locale) {
    return `&locale=${locale}`
  }
  return ''
}

export const buildCompetitor = competitor => {
  if (competitor) {
    return `&competitor=${competitor}`
  }
  return ''
}

export const buildDivision = (level, key) => {
  if (level && key) {
    return `&subdivision_${level}=${key}`
  }
  return ''
}

export const buildCountries = countries => {
  if (countries && countries.length > 0) {
    return `&countries=${countries.join(',')}`
  }
  return ''
}

export const buildView = view => {
  if (view) {
    return `&view=${view}`
  }
  return ''
}

export const buildGroups = activeGroups => {
  return activeGroups?.length ? `&groups=${activeGroups.join(',')}` : ''
}
